import React, { useEffect, useState }                 from 'react'
import { useDispatch, useSelector }                   from 'react-redux'
import useNavigate                                    from '../../hooks/useNavigate'
import CabHourlyCarouselItemUI                        from '../CabHourlyCarouselItem/CabHourlyCarouselItemUI'
import useCarousel                                    from '../useCarousel/useCarousel'
import Icon                                           from "../../../stories/core-components/IconsSelector"
import * as S                                         from './CabHourlyCarouselStyle'
import { CTA_TYPE, getActionNameForOmniture }         from '../../utils/omni-utils'
import { gcHomeScreen, pushCtaOmniEvents }            from '../../config/omni'
import { 
  hrDefaultPackageSelector, 
  hrDefaultPackageTimeSelector,
  hrPackageSelector 
}                                                     from '../../common/redux/selector'
import { 
  UPDATE_HR_PACKAGE, 
  UPDATE_HR_PACKAGE_TIME, 
  UPDATE_TRIP_TYPE 
}                                                     from '../../pages/SearchPage/redux/action-types'
import { 
  CABS_LANDING_ROUTE, 
  CABS_LISTING_ROUTE, 
  CAB_HOURLY_CAROUSEL_UI, 
  Hr, 
  LOCAL_RENTAL, 
  RENTAL_PACKAGE
}                                                     from '../../utils/util-constants'

const CabHourlyCarouselUI = ({ data, itemCount = 4, onPackageChange, is_static = false, invokedFor = "" }) => {
  const hrSelectedPackageId = useSelector(hrPackageSelector)
  const hrDefaultPackage = useSelector(hrDefaultPackageSelector)
  const hrDefaultPackageTime = useSelector(hrDefaultPackageTimeSelector)
  const [selectedPackage, setSelectedPackage] = useState(hrSelectedPackageId || '')
  const dispatch = useDispatch()
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel((data || []), itemCount)
  const [navigateTo]  = useNavigate()

  useEffect(() => {
    setSelectedPackage(hrSelectedPackageId)
  }, [hrSelectedPackageId])

  const onPackageUpdate = (id, time) => {
    pushCtaOmniEvents(getActionNameForOmniture(invokedFor, `${RENTAL_PACKAGE}_${id}`), CTA_TYPE.BUTTON, CAB_HOURLY_CAROUSEL_UI, invokedFor === gcHomeScreen ? CABS_LANDING_ROUTE : CABS_LISTING_ROUTE)
    setSelectedPackage(is_static ? hrDefaultPackage : id)
    dispatch({
      type        : UPDATE_HR_PACKAGE,
      package_id  : is_static ? hrDefaultPackage : id
    });
    dispatch({
      type        : UPDATE_HR_PACKAGE_TIME,
      packageTime : is_static ? hrDefaultPackageTime : time
    })
    if (is_static) {
      dispatch({
        type: UPDATE_TRIP_TYPE,
        tripType: {
          name: LOCAL_RENTAL,
          rf: Hr
        }
      })
      navigateTo('home')
      return 
    } 

    if (onPackageChange) {
      onPackageChange()
    }
  }

  return (
    <S.CabHourlyCarousel>
      {dataList?.length ? (
        dataList.map((item) => (
          <CabHourlyCarouselItemUI key={item?.name || item?.pkg_id} item={item} onSelect={onPackageUpdate} isSelected={selectedPackage === item?.name || selectedPackage === item?.package_id || selectedPackage === item?.pkg_id} />
        ))
      ) : null}
      {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => { 
            increment();
          }}
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            decrement();
          }}
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.CabHourlyCarousel>
  );
};

export default CabHourlyCarouselUI;

